import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Stack,
  Typography,
  Skeleton,
  Box,
  Chip,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";

/**
 * Dropdown selector de location clínica.
 * Muestra nombre de la location + cantidad de pacientes.
 */
export default function LocationSelector({
  locations,
  selectedLocation,
  onChangeLocation,
  loading,
}) {
  if (loading) {
    return <Skeleton variant="rounded" width={320} height={40} />;
  }

  if (!locations?.length) return null;

  const handleChange = (e) => {
    const loc = locations.find((l) => l.key === e.target.value);
    if (loc) onChangeLocation(loc);
  };

  // Extraer nombre legible de la dirección (primera parte antes de la coma)
  const getLocationName = (loc) => {
    if (loc.key === "unassigned") return "Unassigned";
    const parts = loc.address.split(",");
    // Tomar la segunda parte que suele ser la ciudad
    return parts[1]?.trim() || parts[0]?.trim() || loc.key;
  };

  return (
    <Stack direction="row" alignItems="center" spacing={1.5}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 36,
          height: 36,
          borderRadius: 2,
          bgcolor: "#EFF6FF",
          color: "#2563EB",
        }}
      >
        <LocationOnIcon fontSize="small" />
      </Box>

      <FormControl size="small" sx={{ minWidth: 280 }}>
        <Select
          value={selectedLocation?.key || ""}
          onChange={handleChange}
          displayEmpty
          sx={{
            borderRadius: 2,
            fontWeight: 600,
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              gap: 1,
            },
          }}
          renderValue={(value) => {
            const loc = locations.find((l) => l.key === value);
            if (!loc) return "Select location";
            return (
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="body2" fontWeight={600}>
                  {getLocationName(loc)}
                </Typography>
                <Chip
                  label={`${loc.patients.toLocaleString()} pts`}
                  size="small"
                  sx={{
                    height: 20,
                    fontSize: "0.7rem",
                    fontWeight: 600,
                    bgcolor: "#EFF6FF",
                    color: "#2563EB",
                  }}
                />
              </Stack>
            );
          }}
        >
          {locations.map((loc) => (
            <MenuItem key={loc.key} value={loc.key}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ width: "100%" }}
              >
                <Box>
                  <Typography variant="body2" fontWeight={600}>
                    {getLocationName(loc)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                    {loc.address}
                  </Typography>
                </Box>
                <Chip
                  label={`${loc.patients.toLocaleString()}`}
                  size="small"
                  sx={{
                    ml: 2,
                    height: 20,
                    fontSize: "0.7rem",
                    fontWeight: 600,
                    bgcolor: "#F1F5F9",
                    color: "#475569",
                  }}
                />
              </Stack>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}
